// extracted by css-extract-rspack-plugin
export default {"strip":"V_S0t_"};